module.exports = __webpack_public_path__ + "f27049bb0345f293cfb39da6b64d4407.svg";